import React from "react";
import seeds from "./seeds";
function DailySeed(){
  
  const seed = seeds[(new Date().getDate() - 1) % seeds.length];

  return (
    <section style={{
      background: "#f6fff8",
      border: "1px solid #d8f3dc",
      borderRadius: "20px",
      padding: "24px",
      margin: "30px auto",
      maxWidth: "720px",
      textAlign: "center"
    }}>
      <p style={{
        fontSize: "14px",
        fontWeight: "700",
        color: "#2e7d32",
        marginBottom: "10px",
        letterSpacing: "0.04em",
        textTransform: "uppercase"
      }}>
        🌱 Daily Seed
      </p>

      <h2 style={{
        fontSize: "26px",
        color: "#1f2937",
        margin: "0 0 12px"
      }}>
        {seed}
      </h2>

      <p style={{
        color: "#6b7280",
        margin: "0"
      }}>
        A small reminder for the journey.
      </p>
    </section>
  );
}

export default DailySeed;